import React from 'react';
import PaymentIcon from './payment_icon';

const providerMap = {
  paypal: 'pay_pal',
  paypal_rest: 'pay_pal',
};

const icons = (providers, basePath, className, width, height) =>
  providers.map((provider, key) => (
    <PaymentIcon
      provider={provider}
      path={basePath}
      key={key}
      className={`${className}__payment-icon`}
      width={width}
      height={height}
    />
  ));

const PaymentProviderIcons = (props) => {
  const checkPaymentProviderAvailability = (providerName) =>
    props.paymentProviders.some((provider) => provider.name == providerName);

  const getOtherProvidersArray = () => {
    const otherProviders = ['paypal_rest'];
    return otherProviders
      .filter((provider) => checkPaymentProviderAvailability(provider))
      .map((provider) => providerMap[provider]);
  };
  const className = props.className || 'payment-icons';

  const basePath = `${props.staticFilesServer}/images/spareroom/cards`;
  const localCard =
    window && window._sr && window._sr.site && window._sr.site.country == 'GB'
      ? 'maestro'
      : 'amex';
  const cardIcons = icons(
    ['visa', 'mastercard', localCard],
    basePath,
    className,
    60,
    40,
  );

  let otherProviderIcons = null;
  const otherAvailableProviders = getOtherProvidersArray();
  const providerIcons = icons(
    otherAvailableProviders,
    basePath,
    className,
    63,
    40,
  );
  otherProviderIcons = !otherAvailableProviders.length ? null : (
    <div className={`${className}__other-providers`}>{providerIcons}</div>
  );

  const paymentFormCardIcons = checkPaymentProviderAvailability('stripe') ? (
    <div className={`${className}__cards`}>{cardIcons}</div>
  ) : null;

  return (
    <div className={className}>
      {paymentFormCardIcons}
      {otherProviderIcons}
    </div>
  );
};

export default PaymentProviderIcons;
